import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ClientHandlingErrorStatusCode, EHttpStatusCodeSuccess } from "@devowl-wp/api";
import { useStores } from "../store/root.js";
import { getClient } from "../util/api-fetch.js";
import { QueryKeys } from "../util/query-keys.js";
function useUntranslatableCreate() {
    const { rcbAuthenticationStore } = useStores();
    const queryClient = useQueryClient();
    const createMutation = useMutation(async ({ text, template: { type: templateType, identifier: templateIdentifier } })=>{
        const result = await getClient().template.untranslatable.post({
            request: {
                text,
                template: {
                    type: templateType,
                    identifier: templateIdentifier
                }
            },
            headers: {
                Authorization: `Bearer ${rcbAuthenticationStore?.session?.jwt}`
            }
        });
        switch(result.status){
            case EHttpStatusCodeSuccess.Created:
                return result.response;
            case ClientHandlingErrorStatusCode:
                throw result.error;
            default:
                throw result.response;
        }
    }, {
        onSuccess: ()=>{
            // Invalidate all untranslatables queries to refetch data
            queryClient.invalidateQueries(QueryKeys.getAllUntranslatables());
        }
    });
    return createMutation;
}
export { useUntranslatableCreate };
